import React from "react";
import "./Skeleton.scss";

// One reusable shimmering placeholder block — every Portfolio section
// composes its loading state from this instead of a bespoke design each.
// Shown while PortfolioContext/SettingsContext are still fetching (see
// usePortfolioMeta().loaded) so a section never flashes static config
// defaults and then swaps to different real content once the API resolves
// — it shows a skeleton, then the FINAL content, once.
export const Skeleton = ({width = "100%", height = 16, lines = 1, circle = false, style, className = ""}) => {
  if (lines > 1) {
    return (
      <span className={`rd-skel-group ${className}`} style={style}>
        {Array.from({length: lines}).map((_, i) => (
          <span
            key={i}
            className="rd-skel"
            style={{width: i === lines - 1 ? "65%" : width, height}}
          />
        ))}
      </span>
    );
  }
  return (
    <span
      className={`rd-skel ${circle ? "rd-skel--circle" : ""} ${className}`}
      style={{width, height, ...style}}
    />
  );
};

// Drop-in "shape of a section" placeholder — a heading-sized bar + a few
// body lines — sized close enough to real content that swapping in the
// final section doesn't visibly jump the page around.
export const SkeletonSection = ({minHeight = 280, lines = 3, className = "", id}) => (
  <div className={`rd-skel-section ${className}`} style={{minHeight}} id={id} aria-hidden="true">
    <Skeleton width={220} height={34} style={{marginBottom: 20}} />
    <Skeleton lines={lines} height={14} />
  </div>
);

export default Skeleton;
